import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { sgKeys } from '../queries/keys';
import { sgPaths } from '../queries/paths';

// TSS vite/03 — detalle por vaca física SG (admin-sg.md · B2/B3).
//   useSgCow(cowId)       → GET /admin/sg/cows/:cowId (maestro + último-X agregado +
//                           identidades). 404 si la vaca no existe/no activa/sin fichas.
//   useSgCowEvents({...}) → GET /admin/sg/cows/:cowId/events — historial AGREGADO de
//                           todas las fichas de la vaca, por feature. "Cargar más" =
//                           useInfiniteQuery por offset (las páginas acumuladas viven
//                           en TanStack Query, no en useState — vite/03 [RIGID]).

const HIST_LIMIT = 20;

export function useSgCow(cowId) {
    return useQuery({
        queryKey: sgKeys.cow(cowId),
        queryFn:  ({ signal }) => api.get(sgPaths.cow(cowId), { signal }).then(r => r.data),
        enabled:  !!cowId,
    });
}

export function useSgCowEvents({ cowId, feature, from, to, limit = HIST_LIMIT }) {
    const params = { feature, limit };
    if (from) params.from = from;
    if (to) params.to = to;
    return useInfiniteQuery({
        queryKey: sgKeys.cowEvents(cowId, feature, { from: from || null, to: to || null, limit }),
        queryFn: ({ pageParam, signal }) =>
            api.get(sgPaths.cowEvents(cowId), { params: { ...params, offset: pageParam }, signal }).then(r => r.data),
        initialPageParam: 0,
        getNextPageParam: (last) => {
            const pag = last?.pagination;
            if (!pag) return undefined;
            const next = pag.offset + pag.limit;
            return next < pag.total ? next : undefined;
        },
        enabled: !!cowId && !!feature,
    });
}
